// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1Gp_K","legacyBtn":"MutateMid_legacyBtn__2Ksuz"};